import * as Yup from 'yup';

export const accommodationOfferEvidenceListValidationSchema = Yup.object().shape({
    
});

